<template>
    <div class="w-full flex flex-row mb-3 xl:mb-5 align-items-center cursor-pointer
        xl:max-w-30rem lg:max-w-30rem md:max-w-30rem"
        @click="popup_show()">
        <div class="w-full flex flex-row border-round-2xl surface-300 py-5 px-3">
            <span class="flex flex-1 text-700 font-medium xl:text-xl">
                {{ header[lang_] }}
            </span>
            <i class="pi pi-window-maximize text-700" style="font-size: 1rem"></i>
        </div>
    </div> 
    <Dialog v-model:visible="popup" modal :header="header[lang_]" 
        class="w-full ml-4 mr-4 border-round-xl" style="max-width: 560px;">
        <div class="w-full">
            <p>
                {{ content[lang_].step1 }}
            </p>
            <p>
                {{ content[lang_].step2 }}
            </p>
            <p>
                {{ content[lang_].step3 }}
            </p>
            <img src="/images/info/instructions/kasikorn_cash/k1.jpg" class="w-full">
            
            <p>
                {{ content[lang_].step4 }}
            </p>
            <img src="/images/info/instructions/kasikorn_cash/k2.jpg" class="w-full">
            <p>
                {{ content[lang_].step5 }}
            </p>
            <img src="/images/info/instructions/kasikorn_cash/k3.jpg" class="w-full">
            <p>
                {{ content[lang_].step6 }}
            </p>
            <img src="/images/info/instructions/kasikorn_cash/k4.jpg" class="w-full">
            <p>
                {{ content[lang_].step7 }}
            </p>
        </div>
    </Dialog>
</template>


<script>
import { ref } from "vue";
import Helper from '@/assets/js/Helper'
export default {
    props: [],
	data(){
		return{
            popup: false,
            header: {
                ru: "Как снять наличные в АТМ Kasikorn Bank",
                en: "How to withdraw cash from Kasikorn Bank ATM",
            },
			content: {
                ru: {
					step1: "1. Найдите синий банкомат Kasikorn Bank в вашем городе.",
                    step2: "2. Как только окажетесь у банкомата - напишите заранее оператору и оставайтесь на связи.",
                    step3: "3. Нажмите кнопку Cardless Withdrawal на главном экране банкомата Kasikorn Bank.",
                    step4: "4. Далее нажмите K PLUS",
                    step5: "5. Сканируйте QR код нажав на кнопку 'Сканировать QR код' прямо на этой странице, но ! НЕ нажимайте кнопку Confirm ! до момента, пока наш оператор не подтвердит получение QR кода.",
                    step6: "6. После подтверждения оператора нажмите кнопку Confirm.",
                    step7: "7. Банкомат выдаст вам наличные. Готово.",
				},
				en: {
					step1: "1. Find a blue Kasikorn Bank ATM in your city.",
                    step2: "2. Once you are at the ATM - write to the operator in advance and stay in touch.",
                    step3: "3. Press the Cardless Withdrawal button on the main screen of the Kasikorn Bank ATM.",
                    step4: "4. Next, press K PLUS",
                    step5: "5. Scan the QR code by clicking the 'Scan QR code' button right on this page, but! DO NOT press the Confirm button! until our operator confirms receipt of the QR code.",
                    step6: "6. After the operator confirms, press the Confirm button.",
                    step7: "7. The ATM will dispense cash to you. Done.",
                },
			}, 
		}
	},
	computed: {
		lang_() {
			return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
		},
	},
	methods: {
        popup_show(){
            this.popup = true
        },
	},
	async beforeCreate() {
        this.helper = new Helper()
	}
}
</script>